import * as React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useSession } from '@hooks';

import { NAVIGATION } from '@utils';

const ROUTE_PREFIX = '/me';

export default function MePage() {
  const { account } = useSession();
  const role = account?.__typename ?? 'Guest';
  const navigate = useNavigate();
  const { pathname, state } = useLocation();

  React.useEffect(() => {
    // Only enforce rules inside /me
    if (!pathname.startsWith(ROUTE_PREFIX)) return;

    const [basePath = '/'] = NAVIGATION[role] ?? [];

    // Exact /me -> redirect to default section
    if (pathname === ROUTE_PREFIX) {
      navigate(basePath, { replace: true, state: { ...state } });
      return;
    }

    // Get the authorized paths for the user's role
    const authorizedPaths = NAVIGATION[role] ?? [];

    // Verify if the current route is authorized
    const isAuthorized = authorizedPaths.some((p) => pathname.startsWith(p));

    // Redirection if the user is not on an authorized route
    if (!isAuthorized) {
      navigate(basePath, { replace: true, state: { ...state } });
      return;
    }
  }, [role, pathname, state, navigate]);

  return <Outlet />;
}
